import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { SpControlHandleComponent } from '@ui/sp-control-handle';

import { SpFormAdditionalSettingsComponent } from './sp-form-additional-settings.component';
import { SubscriptionMessageModalComponent } from './subscription-message-modal/subscription-message-modal.component';
import { SpPipesModule } from '@common/pipes/pipes.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { SpCommonEditorModule } from '@components/sp-common-editor';
import { SpSwitchComponent } from '@ui/sp-switch';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        ReactiveFormsModule,
        BsDropdownModule,
        FormsModule,
        SpControlHandleComponent,
        SpPipesModule,
        SpCommonEditorModule,
        SpSwitchComponent,
        TooltipModule,
        SpFormAdditionalSettingsComponent,
        SubscriptionMessageModalComponent,
        NgSelectModule,
    ],
    exports: [SpFormAdditionalSettingsComponent, SubscriptionMessageModalComponent],
})
export class SpFormAdditionalSettingsModule {}
